import LennocInput from '@lennoc/lennoc-components/src/components/LennocInput'
import BaseCheckbox from '@/components/base/BaseCheckbox.vue'
import CountrySelect from '@/components/composed/CountrySelect.vue'
import LennocDateSelector from '@lennoc/lennoc-components/src/components/LennocDateSelector'
// import ClaimLegalRepresentative from '@/components/person/ClaimLegalRepresentative.vue'

import { nonumber, novalidator, phonenumber, justnumbers, email, iban, street, city } from '@/validators/index.js'

const allFields = {

  // General fields
  CountryCode: { key: 'CountryCode', type: 'String', editor: CountrySelect, default: 'NL' },

  // Bankaccount fields
  BIC: { key: 'BIC', type: 'String', editor: LennocInput, validators: [] },
  BankCity: { key: 'BankCity', type: 'String', editor: LennocInput, validators: [] },
  BankName: { key: 'BankName', type: 'String', editor: LennocInput, validators: [nonumber] },
  Bankleitzahl: { key: 'Bankleitzahl', type: 'String', editor: LennocInput, validators: [] },
  Holder: { key: 'Holder', type: 'String', editor: LennocInput, validators: [nonumber] },
  IBAN: { key: 'IBAN', type: 'String', editor: LennocInput, validators: [iban] },
  Number: { key: 'Number', type: 'String', editor: LennocInput, validators: [] },
  Valid: { key: 'Valid', type: 'Boolean', editor: BaseCheckbox },
  PayPalEMailAccount: { key: 'PayPalEMailAccount', type: 'String', editor: LennocInput, validators: [email] },

  // Passenger fields
  BirthDate: { key: 'BirthDate', type: 'String', editor: LennocDateSelector },
  BirthPlace: { key: 'BirthPlace', type: 'String', editor: LennocInput, validators: [nonumber] },
  City: { key: 'City', type: 'String', editor: LennocInput, validators: [city] },
  EMailAddress: { key: 'EMailAddress', type: 'String', editor: LennocInput, validators: [email] },
  FirstName: { key: 'FirstName', type: 'String', editor: LennocInput, validators: [nonumber] },
  Gender: { key: 'Gender', type: 'String', editor: LennocInput, validators: [] },
  HouseNumber: { key: 'HouseNumber', type: 'String', editor: LennocInput, validators: [justnumbers] },
  HouseNumberExtension: { key: 'HouseNumberExtension', type: 'String', editor: LennocInput, validators: [] },
  LastName: { key: 'LastName', type: 'String', editor: LennocInput, validators: [nonumber] },
  MiddleName: { key: 'MiddleName', type: 'String', editor: LennocInput, validators: [nonumber] },
  PhoneNumber: { key: 'PhoneNumber', type: 'String', editor: LennocInput, validators: [phonenumber] },
  PostalCode: { key: 'PostalCode', type: 'String', editor: LennocInput, validators: [novalidator] },
  StreetName: { key: 'StreetName', type: 'String', editor: LennocInput, validators: [street] },
  CanModify: { key: 'CanModify', type: 'Boolean', editor: BaseCheckbox },
  CanComplete: { key: 'CanComplete', type: 'Boolean', editor: BaseCheckbox },
  Id: { key: 'Id', type: 'String', editor: LennocInput, validators: [] },
  IsMinor: { key: 'IsMinor', type: 'Boolean', editor: BaseCheckbox },
  IsPassportCheckComplete: { key: 'IsPassportCheckComplete', type: 'Boolean', editor: BaseCheckbox },
  PassportNumber: { key: 'PassportNumber', type: 'String', editor: LennocInput, validators: [] },
  TicketNumber: { key: 'TicketNumber', type: 'String', editor: LennocInput, validators: [] }
}

const getFormField = function (key) {
  return allFields[key] || null
}

const getFormFields = function (fieldkeys) {
  const result = {}
  const keys = Array.prototype.flat.call(fieldkeys)

  keys.forEach(key => {
    const field = getFormField(key)
    if (field) {
      result[key] = { ...field }
    }
  })
  return result
}

export {
  getFormFields
}
